<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <fa-icon [icon]="actionIcon"></fa-icon>
    <h2 ngpDialogTitle>{{ dialogTitle }}</h2>
    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>
  <ng-template suiDialogContent>
    <div class="sentiment-wrapper">
      <div
        class="sentiment-options"
        sui-radio-group
        [formControl]="sentimentControl"
        orientation="vertical"
      >
        @for (sentiment of sentimentValues; track sentiment.value) {
          <sui-radio [value]="sentiment.value">{{ sentiment.label }}</sui-radio>
        }
      </div>

      @if (sentimentManualChanges.length > 0) {
        <span class="sentiment-manual-change-title">
          {{ "post-sentiment.title.sentiment-scored-manually-by" | translate }}
        </span>
        @for (
          change of sentimentManualChanges;
          track change.user + "-" + change.time_scored
        ) {
          @for (change of sentimentManualChanges; track change) {
            <div class="sentiment-manual-change">
              @for (field of sentimentManualChangesFields; track field.id) {
                <div class="change-info">
                  <span class="label">
                    {{ "post-sentiment.label." + field.label | translate }}
                  </span>
                  @if (!field.isImage) {
                    <span class="value">{{ field.value(change) }}</span>
                  }
                  @if (field.isImage) {
                    <img
                      [src]="field.value(change)"
                      style="width: 1.7rem; height: 1.7rem; border-radius: 50%"
                    />
                  }
                </div>
              }
            </div>
          }
        }
      }
    </div>
  </ng-template>
  <ng-template suiDialogFooter>
    <sui-button size="sm" variant="secondary" (click)="cancel()">
      {{ "btn.cancel" | translate }}
    </sui-button>
    <sui-button
      size="sm"
      variant="primary"
      [disabled]="sentimentControl.invalid"
      (click)="save()"
    >
      {{ "btn.confirm" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
